import { render, staticRenderFns } from "./HsMatchedStudents.vue?vue&type=template&id=4239b835&"
import script from "./HsMatchedStudents.vue?vue&type=script&lang=js&"
export * from "./HsMatchedStudents.vue?vue&type=script&lang=js&"
import style0 from "./HsMatchedStudents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports